<template>
  <div>
    <!-- Start Bradcaump area -->
    <div class="bradcaump_area bg_image--4">
      <div class="container">
        <div class="row">
          <div class="col-lg-12">
            <div class="bradcaump_inner text-center">
              <h2 class="bradcaump-title">产品 Product</h2>
              <nav class="bradcaump-content">
                <b-link class="breadcrumb_item" to="/home">Home</b-link>
                <span class="brd-separetor">/</span>
                <span class="breadcrumb_item active">Products</span>
              </nav>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- End Bradcaump area -->
    <!-- Start Shop Area -->
    <div class="shop_area section-ptb-xl bg--white">
      <div class="container">
        <div class="row">
          <div class="col-lg-3 col-12 order-1 order-lg-1 sm-mt--30 md-mt--30">
            <div class="shop_sidebar">
              <!-- Start Single Wedget 产品分类 -->
              <div class="sidebar_widget widget_categories mb--60">
                <h2 class="sidebar_title">分类 Categories</h2>
                <ul class="sidebar_categories">
                  <li class="link_active">
                    <b-link @click="changeProductCatalog()">
                      所有产品
                      <span></span>
                    </b-link>
                  </li>
                  <li v-for="item in pro_menu_list" :key="item.pk">
                    <b-link @click="changeProductCatalog(item.pk)" active>
                      {{ item.name }}
                      <span>({{item.count }})</span>
                    </b-link>
                  </li>
                </ul>
              </div>
              <!-- End Single Wedget -->

              <!-- Start Single Wedget -->
              <div class="sidebar_widget widget_banner mb--60 hidden-sm-and-down">
                <div class="sidebar_banner"><img src="../assets/img/banner/sidebar-banner.png" alt="sidebar banner" /></div>
              </div>
              <!-- End Single Wedget -->

              <!-- Start Single Wedget -->
              <div class="sidebar_widget search mb--60">
                <h2 class="sidebar_title">搜索 Search</h2>
                <div class="sidebar_search">
                  <b-form @submit="search">
                    <b-form-input type="text" name="keywords" placeholder="关键字" v-model="keywords" required />
                    <b-button type="submit" squared><i class="ti-search"></i></b-button>
                  </b-form>
                </div>
              </div>
              <!-- End Single Wedget -->
              <!-- Start Single Wedget -->
              <div class="sidebar_widget widget_tag hidden-sm-and-down">
                <h2 class="sidebar_title">标签 Tags</h2>
                <ul class="sidebar_tag">
                  <b-button
                  variant="outline-dark"
                  squared
                  class="label"
                  v-for="item in labels"
                  :key="item.key"
                  @click="labelTap(item)"
                  >
                  {{item}}
                  </b-button>
                </ul>
              </div>
              <!-- End Single Wedget -->
            </div>
          </div>

          <div class="col-lg-9 col-12 order-2 order-lg-2">
            <div class="shop_product_area">
              <div class="shop-bar-area">
                <div class="shop-filter-tab">
                  <!-- {{ pro_list[0].column__name || '' }} -->
                </div>
                <!-- 搜索操作栏 -->
                <div class="shop-found-selector">
                  <p style="font-weight: 600;">共 {{ pro_list.length }} 条记录</p>
                </div>
              </div>

              <div class="tab_content">
                <div class="row single_grid_product tab-pane fade show active">
                  <!-- Start Single Product -->
                  <div class="col-12" v-for="item in pro_list" :key="item.pk">
                    <div class="product_list">
                      <div class="product_list__thumb pro_thumb">
                        <b-link :to="'/procont/' + item.pk + '/'"><img :src="$domainPrefix + item.thumb" alt="product img" class="pro_thumb" /></b-link>
                      </div>
                      <div class="product_list__content">
                        <h4>
                          <b-link :to="'/procont/' + item.pk + '/'">{{ item.title }}</b-link>
                        </h4>
                        <ul class="price">
                          <li> {{ item.spec }}</li>
                        </ul>
                        <p>{{ item.abstract }}</p>
                      </div>
                    </div>
                    <!-- End Single Product -->
                  </div>
                </div>
                <div v-if="pro_list.length==0" >
                  无产品信息 No Data
                </div>
                <ul class="pagination_style">
                  <li><a class="active" href="#">1</a></li>
                </ul>
              </div>
            </div>
          </div>
        </div>
      </div>
      <!-- End Shop Area -->
    </div>
  </div>
</template>

<script>
export default {
    data () {
        return {
            pro_menu_list: [],
            pro_list: [],
            keywords: '',
            catalog: '',
            currentPage: 1,
            pageSize: 10,
            labels: [ '康洁来', '多酶', '润滑', '除锈', '5L']

        }
    },
    watch: {},
    created: function () {
    // 获取产品分类
        let that = this
        this.$axios
            .get('/api/getgoodscolumn/', {})
            .then(function (res) {
                that.pro_menu_list = res.data
            })
            .catch(function (error) {
                console.log(error)
            })
        // 获取产品信息
        this.getData()
    },
    methods: {
    // 通用函数-获取数据
        getData (keywords, catalog, currentPage, pageSize) {
            // 参数：查询关键字、类目、当前页、每页数据量
            let that = this
            this.$axios
                .get('/api/getgoodslist/', {
                    params: {
                        keywords: keywords,
                        currentpage: currentPage,
                        catalog: catalog,
                        pagesize: pageSize
                    }
                })
                .then(function (res) {
                    that.pro_list = res.data
                })
                .catch(function (error) {
                    console.log(error)
                    that.loading = false
                })
        },
        // 修改产品分类
        changeProductCatalog (catalog) {
            this.getData('', catalog, '', '')
            this.catalog = catalog
        },
        // 关键字搜索产品
        search (evt) {
            evt.preventDefault()
            let that = this
            this.getData(that.keywords, '', '', '')
        },
        labelTap (keywords) {
            this.getData(keywords, '', '', '')
        }
    }
}
</script>

<style scoped>
.link_active {
  border-bottom: 1px solid #000000;
  padding: 5px;
  border-radius: 2px 2px;
}

/* a {
  text-decoration: none;
} */
.label {
  margin-right: 5px;
   margin-bottom: 5px;
   font-family: "Oswald", sans-serif;
   font-size: 16px;
   font-weight: 400;
   line-height: 26px;
   padding: 5px 14px;
}
.active {
  color: #007BFF;
}
.pro_thumb {
  height: 250px;
  overflow: hidden;
  text-align: center;
}
.pro_thumb :hover {
  -webkit-animation: movein 1s linear forwards; /* Chrome, Safari, Opera */
  animation: movein 1s linear forwards;
}

@keyframes movein {
  0% {
    transform: rotate(0deg);
  }
  30% {
    transform: rotate(-15deg);
  }
  60% {
    transform: rotate(15deg);
  }
  100% {
    -webkit-transform: rotate(0deg);
  }
}
</style>
